var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from '../../i18n';
import * as FormActions from '../../store/form/actions';
import CheckBox from '../CheckBox';
import FieldRead from '../FieldRead';
import Loading from '../Loading';
import TopNavigation from '../TopNavigation';
import { ConfirmButton, Container, Fields, VersionText } from './styles';
import TermsConsent from './TermsConsent';
import { isTermsConsentStep } from './termsConsentClassifier';
var StepRead = function (_a) {
    var step = _a.step, onPressConfirm = _a.onPressConfirm, loading = _a.loading;
    var form = useSelector(function (state) { return state.form; }).form;
    var theme = useSelector(function (state) { return state.theme; }).theme;
    var t = useTranslation().t;
    var _b = React.useState(false), enableButton = _b[0], setEnableButton = _b[1];
    var dispatch = useDispatch();
    var currentStep = form.steps[step];
    var visibleFields = currentStep.fields
        .map(function (field, index) { return ({ field: field, index: index }); })
        .filter(function (_a) {
        var field = _a.field;
        return field.visible;
    });
    var readFields = visibleFields.filter(function (_a) {
        var field = _a.field;
        return field.type === 'READ';
    });
    var textFields = visibleFields.filter(function (_a) {
        var field = _a.field;
        return field.type === 'TEXT';
    });
    var checkboxFields = visibleFields.filter(function (_a) {
        var field = _a.field;
        return field.type === 'CHECKBOX';
    });
    var isTermsConsent = isTermsConsentStep(currentStep);
    React.useEffect(function () {
        var isValid = true;
        form.steps[step].fields.forEach(function (field) {
            if (field.required && !field.value) {
                isValid = false;
            }
            if (field.required && field.value && field.value === 'false') {
                isValid = false;
            }
        });
        setEnableButton(isValid);
    }, [form]);
    var handleCheckboxChange = function (fieldIndex, value) {
        var newForm = __assign({}, form);
        newForm.steps[step].fields[fieldIndex].value = value;
        dispatch(FormActions.setForm(newForm));
    };
    if (isTermsConsent) {
        return (React.createElement(TermsConsent, { checkboxFields: checkboxFields, enableButton: enableButton, formStep: currentStep, loading: loading, readFields: readFields, textFields: textFields, onChangeCheckbox: handleCheckboxChange, onPressConfirm: onPressConfirm }));
    }
    return (React.createElement(Container, null,
        React.createElement(TopNavigation, { headerPadding: theme.logoPosition !== 'header' ? 1 : 0, headerTransparent: form.steps[step].headerTransparent, showBackButton: form.steps[step].goBack, showLogo: true, title: form.steps[step].showStepName ? form.steps[step].stepName : '' }),
        React.createElement(Fields, null,
            form.steps[step].fields.map(function (field, index) {
                if (field.visible) {
                    if (field.type === 'TEXT') {
                        return (React.createElement(VersionText, { key: index },
                            field.label,
                            " ",
                            field.value));
                    }
                    if (field.type === 'READ')
                        return React.createElement(FieldRead, { key: index, field: field });
                    if (field.type === 'CHECKBOX') {
                        return (React.createElement(CheckBox, { field: field, key: index, onChange: function (value) {
                                var newForm = __assign({}, form);
                                newForm.steps[step].fields[index].value = value;
                                dispatch(FormActions.setForm(newForm));
                            } }));
                    }
                }
                return null;
            }),
            React.createElement(ConfirmButton, { disabled: !enableButton || loading, termsAccepted: enableButton, text: t('common.continue'), onClick: onPressConfirm })),
        loading && React.createElement(Loading, null)));
};
export default StepRead;
